import React, { useState, useEffect, useContext, useRef } from "react";
import "../../css_files/Master/SubCategoryMaster.css";
import AddSubCategoryMaster from "./AddSubCategoryMaster";
import SearchSubCategoryMaster from "./SearchSubCategoryMaster";
import Table from "../Homepage/Table";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function SubCategoryMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Subcategory Name", "Description", "Category Name"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [subcategoryupdatedata, setsubcategoryupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [totalcount, setTotalCount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);
  const [SubIds, setSubIds] = useState([]);
  const [subcategoryId, setSubcategoryId] = useState(null);

  function fetchsubcategorydata(subcategoryid) {
    setsubcategoryupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/SubCategory/GetSubCategoryByIdOrName?id=${subcategoryid}&page=1`;
    axiosInstance
      .get(url)
      .then((res) => {
        setsubcategoryupdatedata(res.data.data[0]);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const fetchSubCategories = async () => {
      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_API_URL}/api/v1/SubCategory/${pagenumber}`,
          {
            Id: subcategoryId || null,
            Search: search,
            Ids,
            SubIds,
          }
        );
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [
            x.id,
            x.name,
            x.description,
            x.category.name,
          ])
        );
      } catch (error) {
        console.error(error);
      } finally {
        setloading(false);
      }
    };

    fetchSubCategories();
  }, [reload, pagenumber, Ids.length, SubIds.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Sub-Category" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Sub-Category" &&
        x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Sub-Category" &&
        x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Sub-Category" &&
        x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="sub-category-master">
      <h1>Sub Category Master</h1>
      <blockquote className="sub-category-master-forms">
        <AddMaster
          text="Add Sub-Category Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search Sub-Category Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddSubCategoryMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          subcategorypdatedata={subcategoryupdatedata}
          key={`${subcategoryupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchSubCategoryMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setIds={setIds}
          setSubIds={setSubIds}
          setSubcategoryId={setSubcategoryId}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchsubcategorydata}
        url="SubCategory/UpdateSubCategory"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default SubCategoryMaster;
